<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import BroadcastBase from '../../../../../broadcasts/components/BroadcastBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <BroadcastBase />
</template>